import React, { useState, useEffect, useRef } from 'react';
import './AboutProximaText.css';
import proximaLogo from '../Head_Logo_Pixel2.png';


const AboutProximaText = () => {
    const [activeFaction, setActiveFaction] = useState(null);

    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef();


    const getImage = (imageName) => require(`./images/${imageName}`);


    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        });

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);


    const renderFactionInfo = () => {
        switch (activeFaction) {
            case 'celestialfaction':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Celestial</strong></p>
                        <div className="blue-glow-divider"></div>

                        <p>
                            Celestials are an alien race that has come from beyond the galactic rim, appearing seemingly out of nowhere.
                            Little is known about their society or origins.
                            Their movements and intentions remain unclear to Tellurian generals.
                            Their fighters are exceptionally formidable, boasting immense power capacity making energy weapons and equipment devastatingly effective.
                            Rumors persist of a great purpose for their silent expansion across the Proxima Universe, but no trend has emerged.
                        </p>
                    </div>
                );
            case 'machinafaction':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Machina</strong></p>
                        <div className="blue-glow-divider"></div>

                        <p>
                            Machina are a race of robotics that have emerged from the depths of Xycon, a dead planet long thought to have been home to an ancient,
                            vanished civilization. Their emergence is a mystery; Did they build themselves, are they the remnants of the lost civilization?
                            These... creatures... possess a disconcerting natural regenerative capability.
                            Over time, their metal heals, and damaged components reform.  They seem to communicate through a subspace network, 
                            indecipherable to others. Their behavior is largely unpredictable,
                            and many have reported seeing them systematically gathering technology, suggesting a long term 
                            unknown plan. Engage with caution.
                        </p>
                    </div>
                );
            case 'tellurianfaction':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Tellurian</strong></p>
                        <div className="blue-glow-divider"></div>

                        <p>
                            Tellurians are human from planet Earth.
                            They are known for their inherent resilience and remarkable aptitude for engineering.
                            
                            Their fighters are highly adaptable, frequently modifying their fighters with scavenged parts and ingenious modifications,
                            a necessity born from their limited resources and a culture that values improvisation above all else.
                            Earths early history was marked by scarcity and conflict, creating a deeply ingrained belief in self reliance and ingenuity.
                            
                        </p>
                    </div>
                );
            case 'satoshifaction':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Satoshi</strong></p>
                        <div className="blue-glow-divider"></div>

                        <p>
                            The Satoshi Rogues are defectors of the tyrannical Satoshi Empire, a vast and militaristic power known for its brutal inefficiency
                            and unwavering pursuit of galactic dominance.  Lord Satoshi, a cruel and paranoid ruler, has deemed them traitors and issued a
                            universal warrant for their capture.  Forced to flee, they find refuge among the many worlds of the Proxima Universe,
                            constantly looking over their shoulders, organizing to build a resistance.  They are skilled smugglers and saboteurs,
                            possessing invaluable knowledge of the Empire's weaknesses.

                        </p>
                    </div>
                );
            default:
                return null;
        }
    };

    const renderFighterInfo = () => {
        switch (activeFaction) {
            case 'celestial':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Celestial Fighters</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('celestialfighter559.jpg')} alt="Celestial Fighter" className="proximacoin-image" />
                        <p>
                            Celestial fighters grant substantially increased power capacity, facilitating extensive integration of energy based
                            weapon systems and advanced components. Their energy weapons and modules are more efficient and effective. They have 
                            base shield capabilities that can reduce or elimiate incoming damage.
                        </p>
                    </div>
                );
            case 'machina':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Machina Fighters</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('machinafighter398.jpg')} alt="Machina Fighter" className="proximacoin-image" />
                        <p>
                            Machina fighters utilize a regenerative armor plating composed of adaptive polymers, providing resistance to a wide range of
                            environmental factors and mitigating damage from sustained fire. 
                        </p>
                    </div>
                );
            case 'tellurian':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Tellurian Fighters</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('tellurianfighter171.jpg')} alt="Tellurian Fighter" className="proximacoin-image" />
                        <p>
                            Tellurian fighters are designed with a modular architecture emphasizing adaptability and ease of modification. Standard fighter
                            configurations feature additional universal modification slots, allowing for unique customization.
                        </p>
                    </div>
                );
            default:
                return null;
        }
    };

    const renderProxBotInfo = () => {
        switch (activeFaction) {
            case 'celestialbot':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Celestial ProxBots</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('celestialbot142.png')} alt="Celestial Bot" className="proximacoin-image" />
                        <p>
                            Celestial ProxBots are renowned for their advanced computational abilities and unparalleled capacity for strategic planning.
                            They excel in optimizing energy infrastructure and information systems, vital for managing a
                            thriving ProxNation.

                            As pilots they are capable of seeing different electromagnetic spectrums, making enemy stealth and level anomalies more apparent.
                        </p>

                        <p>
                            Celestial Bots can only pilot Celestial fighters.
                        </p>
                    </div>
                );
            case 'machinabot':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Machina ProxBots</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('machinabot411.png')} alt="Machina Bot" className="proximacoin-image" />
                        <p>
                            Machina ProxBots directive is to control resource management and defense.
                            They specialize in automating industrial processes; Their operational directives commonly prioritize resource refinement,
                            ensuring the long-term sustainability of their ProxNation.

                            Machina pilots specialize in defensive systems and suffer lower EXP loss on mission falures.
                            
                        </p>

                        <p>
                            Machina Bots can only pilot Machina fighters.
                        </p>
                    </div>
                );
            case 'tellurianbot':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Tellurian ProxBots</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('tellurianbot93.png')} alt="Tellurian Bot" className="proximacoin-image" />
                        <p>
                            Tellurian ProxBots possess exceptional adaptability and a talent for problem-solving.
                            They specialize in customizing industries to suit specific needs and optimizing production lines. Their governing principles favor versatility,
                            adaptable industries.

                            Tellurian pilots gain additional stat boots each level making them well rounded.
                        </p>

                        <p>
                            Tellurian Bots can only pilot Tellurian fighters.
                        </p>
                    </div>
                );

            case 'satoshibot':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Satoshi Rogue ProxBots</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('satoshibot137.png')} alt="Satoshi Bot" className="proximacoin-image" />
                        <p>
                            Satoshi Rogue ProxBots are general for hire agents. They can fill any and all roles in Proxima Universe.

                        </p>

                        <p>
                            Satoshi pilots can operate any fighter from all races and can manage all industries without issue.
                        </p>

                    </div>
                );
            default:
                return null;
        }
    };


    const renderCitizenInfo = () => {
        switch (activeFaction) {
            case 'littlebits':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>LittleBits</strong></p>
                        <div className="blue-glow-divider"></div>
                                <img src={getImage('9301.gif')} alt="LittleBits" className="proximacoin-image" />
                        <p>
                            LittleBits serve as the core civilian population for the Tellurian race, spread across multiple worlds. They fill all civilian roles in the Proxima Universe.
                        </p>
                    </div>
                );
            case 'multiworms':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>MultiWorms</strong></p>
                        <div className="blue-glow-divider"></div>
                                <img src={getImage('245.png')} alt="MultiWorms" className="proximacoin-image" />
                        <p>
                            MultiWorms are found all over the Proxima universe on soil rich planets. They specialze in earth sciences and are skilled in resource extraction.
                        </p>
                    </div>
                );
            case 'pandas':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Pandas</strong></p>
                        <div className="blue-glow-divider"></div>
                                <img src={getImage('49.jpg')} alt="Pandas" className="proximacoin-image" />
                        <p>
                            Pandas are found primarily on forest planets within the Proxima Universe. Tending to be brutes and excellent engineers, they serve well for heavy labor and
                            engineering. 
                        </p>
                    </div>
                );
            default:
                return null;
        }
    };

    const renderEnemyInfo = () => {
        switch (activeFaction) {
            case 'txncleaver':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>TXN Cleaver</strong></p>
                        <div className="blue-glow-divider"></div>
                                <img src={getImage('Txncleaver.gif')} alt="TxnCleaver" className="proximacoin-image" />
                        <p>
                            Once a transaction monitor, now a weaponized fighter, Txncleaver zigzags, laying digital mines with precise timing.
                            Designed to disrupt and punish, it leaves a trail of destruction for any who dare follow.
                            
                        </p>
                    </div>
                );
            case 'bytecore':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Byte Core</strong></p>
                        <div className="blue-glow-divider"></div>
                                <img src={getImage('Bytecore.gif')} alt="ByteCore" className="proximacoin-image" />
                        <p>
                            Bytecore locks onto vertical coordinates before charging forward in a desperate dash. Whether destroyed or ignored, it erupts in a
                            volatile explosion, vaporizing anything caught in its blast radius.
                            
                        </p>
                    </div>
                );
            case 'cryptogolem':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Crypto Golem</strong></p>
                        <div className="blue-glow-divider"></div>
                                <img src={getImage('Cryptogolem.gif')} alt="CryptoGolem" className="proximacoin-image" />
                        <p>
                            An ancient warframe repurposed by the Satoshi Empire, the Cryptogolem hovers before releasing a precision shot. Once activated,
                            it glides in a sine wave pattern, tearing across the stars with force.
                        </p>
                    </div>
                );
            default:
                return null;
        }
    };


    const renderResourceInfo = () => {
        switch (activeFaction) {
            case 'ironore':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Iron Ore</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('IronOre.png')} alt="IronOre" className="proximacoin-image" />
                        <p>
                            Iron ore is a fundamental resource vital for all structural construction, building fabrication, weapon manufacturing,
                            and ammunition production. It serves as a universal building block for ProxNations infrastructure and defense capabilities.
                            Insufficient iron ore reserves severely limit growth.
                        </p>
                    </div>
                );
            case 'copperore':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Copper Ore</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('CopperOre.png')} alt="CopperOre" className="proximacoin-image" />
                        <p>
                            Copper ore is critically important for energy system fabrication and serves as a primary constituent in ammunition casing.
                            Its exceptional electrical conductivity enhances energy transfer efficiency, while its robust nature improves ammunition
                            stability and penetration capabilities.
                        </p>
                    </div>
                );
            case 'manganese':
                return (
                    <div className="faction-container">
                        <div className="blue-glow-divider"></div>
                        <p><strong>Magnesium Ore</strong></p>
                        <div className="blue-glow-divider"></div>
                        <img src={getImage('ManganeseOre.png')} alt="Magnesium" className="proximacoin-image" />
                        <p>
                            Magnesium is utilized primarily in the manufacturing of advanced munitions, including propellants and specialized explosive compounds.
                            It also finds applications in various industrial processes requiring lightweight, high strength materials.
                            
                        </p>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="proxima-text">
            <div className="red-glow-divider"></div>
            <p><strong>What is Proxima?</strong></p>
            <div className="red-glow-divider"></div>

            <img src={proximaLogo} alt="Proxima Logo" className="proxima-image" />
            <p>
                Proxima is a retro style scifi gaming ecosystem, honoring old retro games but adding a twist.
                Proxima is built on blockchain technology allowing the entire ecosystem to seamlessly work together
                with the goal to create an expansive economy impacting gameplay.
            </p>

            <p>
                Leveraging the possibilities that blockchain technology allows with digital asset ownership, we plan
                to build a dynamic economy where everything is commodified. From game power ups, ammo, resources, to buildings,
                upgrades and units. To do this we use NFTs and fungible tokens to represent ecosystem game/utility
                pieces, which can be freely traded in Proximas ecosystem.
            </p>

            <div className="blue-glow-divider"></div>
            <div ref={ref}>
                {isVisible && (
                    <img src={getImage('proxcoin2.gif')} alt="Proxima Coin" className="proximacoin-image" />
                )}
            </div>
            <div className="blue-glow-divider"></div>


            <p>
                At the center of the Proxima ecosystem is the PROX token. The PROX token will be used in every
                interaction within the wider ecosystem, from in game power ups to resource production and refinement,
                to NFT creation. The PROX token is what powers our ecosystem.
            </p>

            <div className="red-glow-divider"></div>
            <p><strong>Lord Satoshi</strong></p>
            <div className="red-glow-divider"></div>

            <p>
                Lord Satoshi is a commander of unparalleled ambition and ruthless determination, consumed by a desire to subjugate the entire Proxima Universe
                under his absolute rule. He rejects the principles of distributed power and efficiency, instead seeking to consolidate Hashpower, the very
                essence of energy and power, into a handful of select strongholds.
            </p>
            <p>
                The Satoshi Empire holds near the galactic center, a strategic location chosen for its proximity to the
                supermassive black hole, the ultimate source of Hashpower. It is from here that Lord Satoshi commands,
                amassing resources and ruling legions in his relentless quest for control. His methods are inefficient and consume vast amounts of 
                resources and Hashpower, but brutal none the less.
            </p>
            <p>
                The Tellurian generals have issued a galactic warning about the Satoshi Empire and are gearing up for war. 
            </p>


            <div className="red-glow-divider"></div>
            <p><strong>Hashpower</strong></p>
            <div className="red-glow-divider"></div>

            <p>
                Hashpower is the invisible prime force of the Proxima Universe, a fundamental energy that permeates all things,
                though intangible and beyond direct interaction.
                Proxima's advanced technology acts as a conduit, guiding Hashpower to fuel essential systems and produce valuable resources.
                For centuries, Tellurian scientists have sought a substance capable of generating Hashpower, but it remains a theory.
            </p>


            <div className="red-glow-divider"></div>
            <p><strong>Core Races</strong></p>
            <div className="red-glow-divider"></div>


            <p>
                In the Proxima Universe there are 4 primary races. Celestial, Machina, Tellurian and Satoshi Rogue. 
            </p>



            <div className="faction-buttons">
                <button onClick={() => setActiveFaction('celestialfaction')}>Celestials</button>
                <button onClick={() => setActiveFaction('machinafaction')}>Machina</button>
                <button onClick={() => setActiveFaction('tellurianfaction')}>Tellurian</button>
                <button onClick={() => setActiveFaction('satoshifaction')}>Satoshi</button>
            </div>

            {renderFactionInfo()}




            
            <div className="red-glow-divider"></div>
            <p><strong>Proxima Fighter NFTs</strong></p>
            <div className="red-glow-divider"></div>
            <p>
                Proxima Fighters are used to play directly in game, Proxima Ascension. Each fighter is represented in game with images and different stats.
                Fighters are critical to obtaining ecosystem NFTs and resources through gameplay. Not only that they serve as part of that races military
                fleet and play supporting roles outside of Proxima Ascension.
            </p>
            <p>
                There are three fighter types: Celestial, Machina, and Tellurian.
            </p>

            <div className="faction-buttons">
                <button onClick={() => setActiveFaction('celestial')}>Celestial</button>
                <button onClick={() => setActiveFaction('machina')}>Machina</button>
                <button onClick={() => setActiveFaction('tellurian')}>Tellurian</button>
            </div>

            {renderFighterInfo()}

            <div className="red-glow-divider"></div>
            <p><strong>ProxBots NFTs</strong></p>
            <div className="red-glow-divider"></div>

            <p>
                Proxima Robots, "ProxBots", represent the citizen leaders of each race. ProxBots are needed to operate and manage your ProxNation, pilot your fighters and more.
                Do you want civil industries or defense industries? ProxBots are used to direct your ProxNations build in specific directions.
            </p>

            <p>
                ProxBots that are used as pilots or other leaders, gain levels, attributes and other skills. They play a crucial role throughout the ecosystem.
            </p>

            <p>
                There are four ProxBot types: Celestial, Machina, Tellurian and Satoshi Rogue.
            </p>


            <div className="faction-buttons">
                <button onClick={() => setActiveFaction('celestialbot')}>Celestial</button>
                <button onClick={() => setActiveFaction('machinabot')}>Machina</button>
                <button onClick={() => setActiveFaction('tellurianbot')}>Tellurian</button>
                <button onClick={() => setActiveFaction('satoshibot')}>Satoshi Rogue</button>
            </div>

            {renderProxBotInfo()}


            <div className="red-glow-divider"></div>
            <p><strong>Proxima Citizens</strong></p>
            <div className="red-glow-divider"></div>

            <p>
                Proxima Citizens are the inhabitants of the Proxima Universe. They are found on various planets and ecosystems throughout the universe.
                Citizens are used to supply labour resources and more to your ProxNation. New species are discovered all the time. But most are young
                races that have yet to develop low level space access.
            </p>

            <div className="faction-buttons">
                <button onClick={() => setActiveFaction('littlebits')}>LittleBits</button>
                <button onClick={() => setActiveFaction('multiworms')}>MultiWorms</button>
                <button onClick={() => setActiveFaction('pandas')}>Pandas</button>
            </div>

            {renderCitizenInfo()}

            <div className="red-glow-divider"></div>
            <p><strong>Enemies</strong></p>
            <div className="red-glow-divider"></div>

            <p>
                The Proxima Universe is a dangerous place and is currently being invaded by the evil Satoshi Empire. You will encounter dozens of different enemies.
            </p>

            <div className="faction-buttons">
                <button onClick={() => setActiveFaction('txncleaver')}>TXN Cleaver</button>
                <button onClick={() => setActiveFaction('bytecore')}>Byte Core</button>
                <button onClick={() => setActiveFaction('cryptogolem')}>Crypto Golem</button>
            </div>

            {renderEnemyInfo()}


            <div className="red-glow-divider"></div>
            <p><strong>Resources</strong></p>
            <div className="red-glow-divider"></div>

            <p>
                Throughout your travels in the Proxima Universe, you will come across different resources that allow you to build and enhance your ProxNation. 
                Resources can be gained through defeating enemies. 
            </p>

            <div className="faction-buttons">
                <button onClick={() => setActiveFaction('ironore')}>Iron Ore</button>
                <button onClick={() => setActiveFaction('copperore')}>Copper Ore</button>
                <button onClick={() => setActiveFaction('manganese')}>Manganese</button>
            </div>

            {renderResourceInfo()}

            <div className="red-glow-divider"></div>

            <p>

                As we expand Proxima Universe you will be able to take your gained resources and craft new NFTs with them. 
            </p>

            <p>
                All resources are dropped through gameplay. All gameplay objects, resources etc are NFTs(Non-Fungible Tokens, ERC721 or ERC1155)
                or Fungible Tokens(ERC20).
            </p>

            <p>
                The PROX token is not emitted through gameplay.
            </p>

            <p>
                As the game and ecosystem are in beta, expect changes and balancing to occur regularly.
            </p>

            <p>
                You will need 1 of the core NFT races to gain access to the beta. Celestial, Machina, Tellurian and Satoshi. Fighters and ProxBots are granted access.
            </p>

        </div>
    );
};

export default AboutProximaText;
